import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from "@angular/common/http";
import * as CarModels from "../../models/car/car";
import { EnvironmentService } from "../../../app/services/environment.service";
import { GarageSearchModel } from "../../models/garage/garageSearch";
import { HelperService } from "../helper/helper.service";
import * as Models from "../../models/commonModels";
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as DepositeModels from '../../models/deposite/deposite';
import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import * as RelocationOrderModels from '../../models/relocation-order/relocation-order';
import * as AldModels from '../../models/ald/ald';
import * as DepoisteModels from "../../models/deposite/deposite";
import * as GarageModels from "../../models/garage/garage";
import * as CarTypeModels from '../../models/car/carType';
import * as TyreParamiterModels from '../../models/tyre/tyreParameters';

@Injectable({
  providedIn: "root",
})
export class AldAnonymousService {
  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private helperService: HelperService
  ) { }


  public checkCar(RegistrationNumber: Models.Request<string>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.CarCheckModel>>(
      `${this.environmentService.getApiURL()}/ald-anonymous/car-check`,
      RegistrationNumber,
      options
    );
  }

  public createGarageVisit(GarageVisit: Models.Request<GarageVisitsModels.GarageVisitModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environmentService.getApiURL()}/ald-anonymous/garage-visit-create`, GarageVisit, options);
  }

  public getGarageVisit(GarageVisit: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environmentService.getApiURL()}/ald-anonymous/get-garage-visit`, GarageVisit, options);
  }

  public getGarages(Request: Models.RequestBase) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageModels.GaragePreviewModel>>(`${this.environmentService.getApiURL()}/ald-anonymous/garage-list`, Request, options);
  }

  public getGaragePreview(Garage: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GaragePreviewModel>>(
      `${this.environmentService.getApiURL()}/ald-anonymous/get-garage-preview`,
      Garage,
      options
    );
  }


  public getGaragePlaceList(Search: GarageVisitsModels.GarageVisitsPlaceSearch) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageVisitsModels.GarageVisitsPlaceListModel>(`${this.environmentService.getApiURL()}/ald-anonymous/garage-places-list`, Search, options);
  }

  public getGarageBlockedDayList(Search: GarageVisitsModels.GarageBlockedHourSearch) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageVisitsModels.GarageBlockedListModel>(`${this.environmentService.getApiURL()}/ald-anonymous/garage-blocked-day-list`, Search, options);
  }

  public getGarageVisits(Search: GarageVisitsModels.GarageVisitsSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageVisitsModels.GarageVisitModel>>(`${this.environmentService.getApiURL()}/ald-anonymous/garage-visit-list`, Search, options);
  }

  public getCarTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<CarTypeModels.CarTypeListModel>(`${this.environmentService.getApiURL()}/ald-anonymous/car-types`);
  }

  public getVisitTyreSources() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<GarageVisitsModels.VisitTyreSourceModel>>(`${this.environmentService.getApiURL()}/ald-anonymous/visit-tyre-sources`);
  }

  public getTyreDiametersList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreDiameterModel>>(`${this.environmentService.getApiURL()}/ald-anonymous/tyre-diameters-list`, options);
  }
}
